/**
 *
 * MyAccountLayout
 *
 */
import * as React from "react";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import { createAbsoluteUrl } from "utils/constants";
import { selectUser } from "app/slice/selectors";
import { MyAccountHeader } from "./my-account-header";
import { MyAccountSidebar } from "./my-account-sidebar";
import { useMobileLineDetails } from "./mobile-line-details-context";
import { StatusBadge } from "./status-badge";
import { Footer } from "../Footer";

import { ScrollArea } from "app/components/ui/scroll-area";

interface Props {}

export const MyAccountLayout = (props: Props) => {
	const location = useLocation();
	const scrollViewportRef = useRef<HTMLDivElement>(null);
	const { isMobileLineDetailsActive } = useMobileLineDetails();
	const user = useSelector(selectUser);
	const displayName =
		user?.firstName || user?.lastName
			? `${user.firstName} ${user.lastName}`
			: "Guest User";

	useEffect(() => {
		if (!user) {
			window.location.href = createAbsoluteUrl();
		}
	}, [user]);

	useEffect(() => {
		const viewport = scrollViewportRef.current?.querySelector(
			"[data-radix-scroll-area-viewport]"
		) as HTMLElement;

		if (viewport) {
			viewport.scrollTo({ top: 0, behavior: "smooth" });
		}
	}, [location.pathname]);

	return (
		<React.Fragment>
			<div
				className={`${
					location.pathname.includes("/dashboard") ? "" : "pt-3"
        } flex flex-col min-h-[calc(100vh-4rem)] sm:min-h-[calc(100vh-6.25rem)] lg:min-h-[calc(100vh-7.5rem)] w-[85.5rem] max-w-[100vw] sm:max-w-[95vw] sm:pt-4 md:pt-5 lg:pt-6 sm:border border-[#E5E7EB] rounded-lg md:rounded-xl mx-auto`}
      >
				{/* h-[calc(100vh-4rem)] sm:h-[calc(100vh-6.25rem)] lg:h-[calc(100vh-7.5rem)] max-h-[65rem] */}
        {!isMobileLineDetailsActive && <MyAccountHeader />}
				<div className="flex overflow-hidden flex-col flex-1 min-h-0 lg:flex-row">
					<MyAccountSidebar />
					<div
						className={`flex-1 min-w-0 ${
							location.pathname.includes("/dashboard")
								? "bg-[#F5F7F9] sm:bg-transparent"
								: ""
						}`}
            // ref={scrollViewportRef}
          >
						{location.pathname.includes("/dashboard") && (
							<div className="flex flex-shrink-0 gap-2 justify-between items-center px-5 py-2 bg-white sm:hidden">
								<h1 className="text-lg sm:text-xl md:text-[1.375rem] lg:text-2xl font-extrabold sm:font-bold leading-6 sm:leading-7 text-black font-mobile">
									Welcome, {displayName}
								</h1>
								<div className="flex items-center gap-1.5 sm:gap-2 md:gap-[0.625rem]">
									<p className="hidden sm:block text-[0.775rem] sm:text-[0.825rem] md:text-sm font-medium leading-5 md:leading-6 text-black">
										Account Status
									</p>
									<StatusBadge isActive={true} />
								</div>
							</div>
						)}
						<Outlet />
					</div>
				</div>
			</div>
      <div className={`${location.pathname.includes("/dashboard") ? "bg-[#F5F7F9] sm:bg-transparent" : ""} pt-6 sm:pt-10 md:pt-12 lg:pt-14 2xl:pt-16`}>
				<Footer />
			</div>
		</React.Fragment>
	);
};
